export function toCamelCase<T = any>(input: any): T {
	if (Array.isArray(input)) {
		return input.map((item) => toCamelCase(item)) as T;
	}

	if (input !== null && typeof input === 'object') {
		return Object.entries(input).reduce((acc, [key, value]) => {
			const camelKey = key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
			(acc as any)[camelKey] = toCamelCase(value);
			return acc;
		}, {} as T);
	}

	return input as T;
}
